<script>
    export default {
        mounted() {
            this.loadTotalUserCount();
        },
        data() {
            return {
                totalUserCount: 0,
            }
        },
        methods: {
            loadTotalUserCount() {
                axios.get(`${Scoop.baseUrl}/api/components/totalUserCount`).then(res => {
                    this.totalUserCount = res.data.totalUserCount;
                })
            },
        }
    }
</script>

<template>
    <div class="ibox float-e-margins">
        <div class="ibox-title">
            <h5>Total Users</h5>
        </div>
        <div class="ibox-content">
            <h1 class="no-margins" v-text="totalUserCount"></h1>
        </div>
    </div>
</template>
